import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'code', label: 'Code' },
  { key: 'name', label: 'Name' },
  { key: 'bank_name', label: 'Bank' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'maturity_date', label: 'Maturity' },
  { key: 'accrued_interest', label: 'Accrued Interest', align: 'right', type: 'money' },
  { key: 'yield', label: 'Yield', align: 'right', type: 'percent' },
  { key: 'idle_cash', label: 'Idle Cash' },
];

export function CashLiquidityReport() {
  return (
    <ReportView
      title="Cash & Liquidity"
      description="Every Cash & Term Deposit holding with accrued interest, yield, and an idle-cash flag, plus the portfolio's overall liquidity ratio."
      endpoint="/reports/investments/cash-liquidity"
      columns={COLUMNS}
      xlsx
    />
  );
}
